const fishList =
    [
        {
            "Key": "132, 250",
            "Code": 1022,
            "Name": "TORSK"
        },
        {
            "Key": 138,
            "Code": 1032,
            "Name": "SEI"
        },
        {
            "Key": 253,
            "Code": 102701,
            "Name": "HYSE"
        },
        {
            "Key": 170,
            "Code": 2311,
            "Name": "KVEITE"
        },
        {
            "Key": 133,
            "Code": 1023,
            "Name": "KVITLANGE"
        },
        {
            "Key": 131,
            "Code": 1021,
            "Name": "BROSME"
        },
        {
            "Key": "189, 265, 266",
            "Code": 2534,
            "Name": "KONGEKRABBE"
        },
        {
            "Key": 265,
            "Code": 253410,
            "Name": "KONGEKRABBE - HANN"
        },
        {
            "Key": 266,
            "Code": 253420,
            "Name": "KONGEKRABBE - HUNN"
        },
        {
            "Key": 100,
            "Code": 211,
            "Name": "HÅBRANN"
        },
        {
            "Key": 101,
            "Code": 212,
            "Name": "BRUGDE"
        },
        {
            "Key": 102,
            "Code": 312,
            "Name": "HÅGJEL"
        },
        {
            "Key": 103,
            "Code": 321,
            "Name": "GRÅHAI"
        },
        {
            "Key": 104,
            "Code": 412,
            "Name": "PIGGHÅ"
        },
        {
            "Key": 105,
            "Code": 414,
            "Name": "HÅ, ANNEN"
        },
        {
            "Key": 106,
            "Code": 435,
            "Name": "SVARTHÅ"
        },
        {
            "Key": 107,
            "Code": 499,
            "Name": "HAI, ANNEN"
        },
        {
            "Key": 108,
            "Code": 511,
            "Name": "STORSKATE"
        },
        {
            "Key": 109,
            "Code": 512,
            "Name": "PIGGSKATE"
        },
        {
            "Key": 110,
            "Code": 513,
            "Name": "FLEKKSKATE"
        },
        {
            "Key": 111,
            "Code": 514,
            "Name": "NEBBSKATE"
        },
        {
            "Key": 112,
            "Code": 515,
            "Name": "GJØKSKATE"
        },
        {
            "Key": 113,
            "Code": 516,
            "Name": "SPISSKATE"
        },
        {
            "Key": 114,
            "Code": 520,
            "Name": "KLOSKATE"
        },
        {
            "Key": 115,
            "Code": 522,
            "Name": "GRÅSKATE"
        },
        {
            "Key": 116,
            "Code": 528,
            "Name": "BURTONSKATE"
        },
        {
            "Key": 117,
            "Code": 529,
            "Name": "SKATE, USPESIFISERT"
        },
        {
            "Key": 118,
            "Code": 553,
            "Name": "HVITSKATE"
        },
        {
            "Key": 119,
            "Code": 559,
            "Name": "SKATER, UPES."
        },
        {
            "Key": 120,
            "Code": 599,
            "Name": "SKATE, ANNEN"
        },
        {
            "Key": 121,
            "Code": 611,
            "Name": "SILD"
        },
        {
            "Key": 122,
            "Code": 711,
            "Name": "LAKS"
        },
        {
            "Key": 123,
            "Code": 732,
            "Name": "PUKKELLAKS"
        },
        {
            "Key": 124,
            "Code": 741,
            "Name": "KVITLAKS"
        },
        {
            "Key": 125,
            "Code": 742,
            "Name": "VASSILD"
        },
        {
            "Key": 126,
            "Code": 743,
            "Name": "STRØMSILD"
        },
        {
            "Key": 127,
            "Code": 751,
            "Name": "LODDE"
        },
        {
            "Key": 128,
            "Code": 811,
            "Name": "ÅL"
        },
        {
            "Key": 129,
            "Code": 821,
            "Name": "HAVÅL"
        },
        {
            "Key": 130,
            "Code": 1011,
            "Name": "MORA (TORSK)"
        },
        {
            "Key": 134,
            "Code": 1024,
            "Name": "BLÅLANGE"
        },
        {
            "Key": 135,
            "Code": 1025,
            "Name": "SKJELLBROSME"
        },
        {
            "Key": 137,
            "Code": 1029,
            "Name": "HVIT LYSING"
        },

        {
            "Key": 139,
            "Code": 1034,
            "Name": "LYR"
        },
        {
            "Key": 140,
            "Code": 1035,
            "Name": "POLARTORSK"
        },
        {
            "Key": 141,
            "Code": 1036,
            "Name": "ØYEPÅL"
        },
        {
            "Key": 142,
            "Code": 1038,
            "Name": "KOLMULE"
        },
        {
            "Key": 143,
            "Code": 1039,
            "Name": "BLEIKE/HVITTING"
        },
        {
            "Key": 144,
            "Code": 1040,
            "Name": "SØLVTORSK"
        },
        {
            "Key": 145,
            "Code": 1051,
            "Name": "LYSING"
        },
        {
            "Key": 146,
            "Code": 1061,
            "Name": "ISGALT"
        },
        {
            "Key": 147,
            "Code": 1062,
            "Name": "SKOLEST"
        },
        {
            "Key": 148,
            "Code": 1411,
            "Name": "SANKTPETERSFISK"
        },
        {
            "Key": 149,
            "Code": 1611,
            "Name": "HESTEMAKRELL(TAGG)"
        },
        {
            "Key": 150,
            "Code": 1671,
            "Name": "HAVBRASME"
        },
        {
            "Key": 151,
            "Code": 1691,
            "Name": "BERGGYLT"
        },
        {
            "Key": 152,
            "Code": 1692,
            "Name": "LEPPEFISK, ANNEN"
        },
        {
            "Key": 153,
            "Code": 1693,
            "Name": "BERGNEBB"
        },
        {
            "Key": 154,
            "Code": 1694,
            "Name": "GRØNGYLT"
        },
        {
            "Key": 155,
            "Code": 1695,
            "Name": "BLÅSTÅL/RØDNEBB"
        },
        {
            "Key": 156,
            "Code": 1711,
            "Name": "GRÅSTEINBIT"
        },
        {
            "Key": 157,
            "Code": 1712,
            "Name": "FLEKKSTEINBIT"
        },
        {
            "Key": 158,
            "Code": 1713,
            "Name": "BLÅSTEINBIT"
        },
        {
            "Key": 159,
            "Code": 1719,
            "Name": "STEINBITER"
        },
        {
            "Key": 160,
            "Code": 1811,
            "Name": "TOBIS OG ANNEN SIL"
        },
        {
            "Key": 161,
            "Code": 2013,
            "Name": "MAKRELL"
        },
        {
            "Key": 162,
            "Code": 2019,
            "Name": "MAKRELLSTØRJE"
        },
        {
            "Key": 163,
            "Code": 2051,
            "Name": "SVERDFISK"
        },
        {
            "Key": 164,
            "Code": 2201,
            "Name": "UER USPESIFISERT"
        },
        {
            "Key": 165,
            "Code": 2202,
            "Name": "UER NORVEGICUS"
        },
        {
            "Key": 166,
            "Code": 2203,
            "Name": "SNABELUER MENTELLA"
        },
        {
            "Key": 167,
            "Code": 2211,
            "Name": "KNURR USPES."
        },
        {
            "Key": 168,
            "Code": 2212,
            "Name": "KNURR"
        },
        {
            "Key": "169, 260, 261",
            "Code": 2221,
            "Name": "ROGNKJEKS"
        },
        {
            "Key": 260,
            "Code": 222120,
            "Name": "ROGNKJEKS - HUNN"
        },
        {
            "Key": 261,
            "Code": 222130,
            "Name": "ROGNKJEKS (OPPDRETT)"
        },
        {
            "Key": 171,
            "Code": 2312,
            "Name": "RØDSPETTE"
        },
        {
            "Key": 172,
            "Code": 2313,
            "Name": "BLÅKVEITE"
        },
        {
            "Key": 173,
            "Code": 2314,
            "Name": "SMØRFLYNDRE"
        },
        {
            "Key": 174,
            "Code": 2315,
            "Name": "GAPEFLYNDRE"
        },
        {
            "Key": 175,
            "Code": 2317,
            "Name": "SANDFLYNDRE"
        },
        {
            "Key": 176,
            "Code": 2318,
            "Name": "LOMRE"
        },
        {
            "Key": 177,
            "Code": 2319,
            "Name": "SKRUBB"
        },
        {
            "Key": 178,
            "Code": 2329,
            "Name": "FLYNDRE, ANNEN"
        },
        {
            "Key": 179,
            "Code": 2341,
            "Name": "TUNGE"
        },
        {
            "Key": 180,
            "Code": 2351,
            "Name": "GLASSVAR"
        },
        {
            "Key": 181,
            "Code": 2352,
            "Name": "SLETTVAR"
        },
        {
            "Key": 182,
            "Code": 2354,
            "Name": "PIGGVAR"
        },
        {
            "Key": 183,
            "Code": 2411,
            "Name": "BREIFLABB"
        },
        {
            "Key": 184,
            "Code": 2511,
            "Name": "KRILL"
        },
        {
            "Key": 185,
            "Code": 2512,
            "Name": "RAUDÅTE"
        },
        {
            "Key": 186,
            "Code": 2513,
            "Name": "KRILL ANTARKTISK"
        },
        {
            "Key": 187,
            "Code": 2524,
            "Name": "REKER"
        },
        {
            "Key": "188, 263, 264",
            "Code": 2532,
            "Name": "TASKEKRABBE"
        },
        {
            "Key": 263,
            "Code": 253210,
            "Name": "TASKEKRABBE - HANN"
        },
        {
            "Key": 264,
            "Code": 253220,
            "Name": "TASKEKRABBE - HUNN"
        },
        {
            "Key": 190,
            "Code": 2535,
            "Name": "TROLLKRABBE"
        },
        //{
        //    "Key": 191,
        //    "Code": 2536,
        //    "Name": "SNØKRABBE"
        //},
        {
            "Key": 192,
            "Code": 2537,
            "Name": "STRANDKRABBE"
        },
        {
            "Key": 193,
            "Code": 2539,
            "Name": "KRABBE, ANNEN"
        },
        {
            "Key": 194,
            "Code": 2541,
            "Name": "SJØKREPS"
        },
        {
            "Key": 195,
            "Code": 2542,
            "Name": "HUMMER"
        },
        {
            "Key": 196,
            "Code": 2548,
            "Name": "TROLLHUMMER"
        },
        {
            "Key": 197,
            "Code": 2560,
            "Name": "FJÆRERUR"
        },
        {
            "Key": 198,
            "Code": 2619,
            "Name": "KUSKJELL"
        },
        {
            "Key": 199,
            "Code": 2620,
            "Name": "SANDSKJELL"
        },
        {
            "Key": 200,
            "Code": 2621,
            "Name": "KAMSKJELL"
        },
        {
            "Key": 201,
            "Code": 2622,
            "Name": "HARPESKJELL"
        },
        {
            "Key": 202,
            "Code": 2623,
            "Name": "BLÅSKJELL"
        },
        {
            "Key": 203,
            "Code": 2624,
            "Name": "OSKJELL"
        },
        {
            "Key": 204,
            "Code": 2626,
            "Name": "HANESKJELL"
        },
        {
            "Key": 205,
            "Code": 2627,
            "Name": "HJERTESKJELL"
        },
        {
            "Key": 206,
            "Code": 2629,
            "Name": "SKJELL, ANNEN"
        },
        {
            "Key": 207,
            "Code": 2634,
            "Name": "AKKAR"
        },
        {
            "Key": 208,
            "Code": 2637,
            "Name": "ANNEN TI-ARMET BLEKKSPRUT"
        },
        {
            "Key": 209,
            "Code": 2638,
            "Name": "BLEKKSPRUT USPES."
        },
        {
            "Key": 210,
            "Code": 2640,
            "Name": "KRÅKEBOLLE"
        },
        {
            "Key": 211,
            "Code": 2642,
            "Name": "BRUN SJØPØLSE"
        },
        {
            "Key": 212,
            "Code": 2643,
            "Name": "RØD SJØPØLSE"
        },
        {
            "Key": 213,
            "Code": 2646,
            "Name": "TEPPESKJELL"
        },
        {
            "Key": 214,
            "Code": 2648,
            "Name": "ALBUSNEGL"
        },
        {
            "Key": 215,
            "Code": 2650,
            "Name": "STRANDSNEGL"
        },
        {
            "Key": 216,
            "Code": 2651,
            "Name": "KONGSNEGL"
        },
        {
            "Key": 217,
            "Code": 2671,
            "Name": "BUTT SANDSKJELL"
        },
        {
            "Key": 218,
            "Code": 2676,
            "Name": "KNIVSKJELL"
        },
        {
            "Key": 219,
            "Code": 2699,
            "Name": "BLØTDYR, ANNEN"
        },
        {
            "Key": 220,
            "Code": 2711,
            "Name": "GRØNLANDSSEL"
        },
        {
            "Key": 221,
            "Code": 2720,
            "Name": "NISE"
        },
        {
            "Key": 222,
            "Code": 2729,
            "Name": "VÅGEKVAL"
        },
        {
            "Key": 223,
            "Code": 2811,
            "Name": "BRUNALGER"
        },
        {
            "Key": 224,
            "Code": 2812,
            "Name": "SUKKERTARE"
        },
        {
            "Key": 225,
            "Code": 2813,
            "Name": "STORTARE"
        },
        {
            "Key": 226,
            "Code": 2814,
            "Name": "FINGERTARE"
        },
        {
            "Key": 227,
            "Code": 2816,
            "Name": "BUTARE"
        },
        {
            "Key": 228,
            "Code": 2817,
            "Name": "BLÆRETANG"
        },
        {
            "Key": 229,
            "Code": 2820,
            "Name": "GRISETANG"
        },
        {
            "Key": 230,
            "Code": 2826,
            "Name": "REMMETANG"
        },
        {
            "Key": 231,
            "Code": 2827,
            "Name": "SAUETANG"
        },
        {
            "Key": 232,
            "Code": 2831,
            "Name": "FJÆREHINNE"
        },
        {
            "Key": 233,
            "Code": 2832,
            "Name": "SØL"
        },
        {
            "Key": 234,
            "Code": 2841,
            "Name": "HAVSALAT"
        },
        {
            "Key": 235,
            "Code": 2871,
            "Name": "TARMGRØNSKE"
        },
        {
            "Key": 236,
            "Code": 2890,
            "Name": "GRISETANGDOKKE"
        },
        {
            "Key": 237,
            "Code": 2899,
            "Name": "TANG OG TARE, ANNEN"
        },
        {
            "Key": 238,
            "Code": 2919,
            "Name": "MARIN FISK, ANNEN"
        },
        {
            "Key": 239,
            "Code": 2999,
            "Name": "USPESIFISERT FISK"
        },
        {
            "Key": 240,
            "Code": 3011,
            "Name": "USPESIFISERTE HAU"
        },
        {
            "Key": 241,
            "Code": 3111,
            "Name": "HAVMUS"
        },
        {
            "Key": 242,
            "Code": 61101,
            "Name": "NORSK VÅRGYTENDE SILD"
        },
        {
            "Key": 243,
            "Code": 61104,
            "Name": "NORDSJØSILD"
        },
        {
            "Key": 244,
            "Code": 61105,
            "Name": "SKAGERAKSILD"
        },
        {
            "Key": 245,
            "Code": 61106,
            "Name": "SILD VEST AV 4 GRADEN"
        },
        {
            "Key": 246,
            "Code": 61501,
            "Name": "HAVBRISLING"
        },
        {
            "Key": 247,
            "Code": 75101,
            "Name": "BARENTSHAVLODDE"
        },
        {
            "Key": 248,
            "Code": 75102,
            "Name": "LODDE ISL/GRL/JM"
        },
        {
            "Key": 249,
            "Code": 102201,
            "Name": "SKREI"
        },
        {
            "Key": 250,
            "Code": 102202,
            "Name": "TORSK"
        },
        {
            "Key": 251,
            "Code": 102204,
            "Name": "TORSK, ANNEN"
        },
        {
            "Key": 252,
            "Code": 102205,
            "Name": "OPPDRETTSTORSK"
        },
        //{
        //    "Key": 136,
        //    "Code": 1027,
        //    "Name": "HYSE"
        //},
        {
            "Key": 254,
            "Code": 102703,
            "Name": "NORDSJØHYSE"
        },
        {
            "Key": 255,
            "Code": 103201,
            "Name": "OPPDRETTSSEI"
        },
        {
            "Key": 256,
            "Code": 103301,
            "Name": "OPPDRETTSSEI (UTGÅTT)"
        },
        {
            "Key": 257,
            "Code": 169510,
            "Name": "BLÅSTÅL"
        },
        {
            "Key": 258,
            "Code": 169520,
            "Name": "RØDNEBB"
        },
        {
            "Key": 259,
            "Code": 222110,
            "Name": "ROGNKALL - HANN"
        },
        {
            "Key": 262,
            "Code": 231101,
            "Name": "OPPDRETTSKVEITE"
        }
    ]

export default fishList



// WEBPACK FOOTER //
// ./Scripts/app/data/fishList.js